import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProfileComponent } from './profile/profile.component';
import { ProfileLandingComponent } from './profile-landing/profile-landing.component';
import { ProfileTabBriefComponent } from './tabs/profile-tab-brief/profile-tab-brief.component';
import { ProfileTabAboutComponent } from './tabs/profile-tab-about/profile-tab-about.component';
import { ProfileTabBusinessComponent } from './tabs/profile-tab-business/profile-tab-business.component';
import { ProfileTabPortfolioComponent } from './tabs/profile-tab-portfolio/profile-tab-portfolio.component';
import { ProfileTabReviewsComponent } from './tabs/profile-tab-reviews/profile-tab-reviews.component';
import { ProfileTabShieldComponent } from './tabs/profile-tab-shield/profile-tab-shield.component';
import { ProfileTabTestimonialsComponent } from './tabs/profile-tab-testimonials/profile-tab-testimonials.component';


const routes: Routes = [
  {
    path: '',
    component: ProfileComponent,
    children: [
      { path: '', component: ProfileLandingComponent },
      { path: 'step1', redirectTo: '', pathMatch: 'full' }
    ]
  },
  {
    path: 'landing',
    component: ProfileLandingComponent,
    children: [
      { path: '', component: ProfileTabBriefComponent },
      { path: 'about', component: ProfileTabAboutComponent },
      { path: 'business', component: ProfileTabBusinessComponent },
      { path: 'portfolio', component: ProfileTabPortfolioComponent },
      { path: 'reviews', component: ProfileTabReviewsComponent },
      { path: 'shield', component: ProfileTabShieldComponent },
      { path: 'testimonials', component: ProfileTabTestimonialsComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfilesRoutingModule { }
